import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    color: '#fff',
  },
  bannerOk: {
    background: 'linear-gradient(135deg, #1b5e20, #43a047)',
  },
  bannerFail: {
    background: 'linear-gradient(135deg, #b71c1c, #ef5350)',
  },
  bannerWarn: {
    background: 'linear-gradient(135deg, #e65100, #ffa726)',
  },
  bannerIcon: {
    fontSize: 56,
  },
  bannerTitle: {
    fontWeight: 700,
  },
  infoCard: {
    padding: theme.spacing(2),
    height: '100%',
  },
  infoLabel: {
    color: theme.palette.text.secondary,
    fontSize: 12,
    textTransform: 'uppercase',
  },
  infoValue: {
    fontWeight: 600,
    wordBreak: 'break-word',
  },
  chipOk: {
    backgroundColor: '#2e7d32',
    color: '#fff',
    fontWeight: 700,
  },
  chipFail: {
    backgroundColor: '#c62828',
    color: '#fff',
    fontWeight: 700,
  },
  chipInfo: {
    backgroundColor: '#546e7a',
    color: '#fff',
    fontWeight: 700,
  },
  chipWarn: {
    backgroundColor: '#ef6c00',
    color: '#fff',
    fontWeight: 700,
  },
  warningPaper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    borderLeft: '6px solid #ef6c00',
    backgroundColor: '#fff3e0',
  },
  sectionTitle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    fontWeight: 700,
  },
}));
